import { apiCall } from '@/services/webservices/shared';

export async function ensureUserDetails( name: string ): Promise<AgentTokenInformation> {
	return await apiCall( `/User/user-information`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ username: name })
	}, 'There was an error fetching user details' );
}
